import React from 'react';
import { SchatztruheIcon } from './icons/SchatztruheIcon';

// Importiere die Schatztruhe-Bilder (wichtig für Webpack)
import chestBronze from '../assets/icons/schatztruhen/chest-bronze.png';
import chestSilver from '../assets/icons/schatztruhen/chest-silver.png';
import chestGold from '../assets/icons/schatztruhen/chest-gold.png';
import chestDiamond from '../assets/icons/schatztruhen/chest-diamond.png';

export function TotalPfandBox({ total }) {
    total = parseFloat(total) || 0;

    const icons = {
        bronze: chestBronze,
        silver: chestSilver,
        gold: chestGold,
        diamond: chestDiamond
    };

    const iconKey = total >= 500
        ? "diamond"
        : total >= 200
        ? "gold"
        : total >= 50
        ? "silver"
        : "bronze";

    return (
        <div style={{
            background: '#fffbe6',
            border: '2px solid #ffd700',
            borderRadius: '12px',
            padding: '1.5rem',
            textAlign: 'center',
            margin: '2rem 0',
            boxShadow: '0 4px 12px rgba(0,0,0,0.05)'
        }}>
            <SchatztruheIcon src={icons[iconKey]}  type={iconKey} alt="Schatztruhe" />
            <h2 style={{ margin: '0.5rem 0', color: '#d48806' }}>{total.toFixed(2)} €</h2>
            <p style={{ color: '#666', fontSize: '1rem' }}>Dein gesamter Schatz seit Nutzung der App</p>
        </div>
    );
}